import axios from "axios";
import { useAuthStore } from "../store/auth.store";

const authApiClient = axios.create({
    baseURL:process.env.REACT_APP_API_AUTH,
    timeout: 30000
    // withCredentials: true
})

authApiClient.interceptors.request.use(config => {
  const authStore = useAuthStore.getState()
  config.headers["Authorization"] = `Bearer ${authStore.accessToken}`
  return config;
});


authApiClient.interceptors.response.use(
  res => res,
  async error => {
    const originalRequest = error.config;
    // 401 (токен протух) и 403 (нет/кривой токен — auth_bearer.py отдаёт 403):
    // оба случая лечатся refresh. См. attachAuthInterceptors.ts.
    const status = error.response?.status;
    if ((status === 401 || status === 403) && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const { refresh } = useAuthStore.getState();
      const {accessToken} = await refresh();
      if (accessToken) {
        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return axios(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);


export default authApiClient